import * as THREE from 'three'
import { createRectsMeshes } from '../utils/helper_functions'
import { getGeometryArray } from '../utils/getGeometryArray'

export const drawRectStanding = (group, options) => {
  const { x, y, width, height } = group
  const { color, scale, opacity = 1 } = options

  const rects = [{ width, height, x, y: y }]

  const { rectMeshes, ring } = createRectsMeshes(rects, options)

  const drawRingBorder = () => {
    const lineBasicMaterial = new THREE.LineBasicMaterial({
      color,
      opacity,
      transparent: true
    })

    const geometries = [new THREE.PlaneGeometry(width * scale, height * scale)]

    ring.borderLines = geometries.map((geometry) => {
      const lineGeometry = new THREE.BufferGeometry()
      const geometryArray = getGeometryArray(geometry)
      const vertices = new Float32Array(geometryArray)

      lineGeometry.setAttribute(
        'position',
        new THREE.BufferAttribute(vertices, 3)
      )
      const line = new THREE.Line(lineGeometry, lineBasicMaterial)
      line.position.set(x * scale, -y * scale, 0)
      ring.add(line)
      return line
    })
  }

  drawRingBorder()

  return { standingArea: ring, rectMeshes }
}
